<template>
  <FormItem
    :prop="prop"
    :label="label"
  >
    <DatePicker
      :value="value.date"
      size="large"
      type="date"
      placeholder=" 年 / 月／ 日"
      format="yyyy年MM月dd日"
      :style="{width: 'calc(100% - 95px)', marginRight: '5px'}"
      :options="options"
      :disabled="disabled"
      :readonly="disabled"
      :editable="false"
      transfer
      @on-change="handleChange($event, 'date')"
    />
    <VueSelect
      :value="value.time"
      :options="timeOptions"
      :on-change="(val) => handleChange(val, 'time')"
      :disabled="disabled || disabledHours"
      class="base-vue-select hide-clear time-select"
      max-height="200px"
      transition="none"
      placeholder="00:00"
    />
    <!-- <TimePicker
      :value="val.time" 
      size="large"
      placeholder="00:00"
      format="HH:mm"
      :style="{width: '80px'}"
      :disabled="disabled"
      :readonly="disabled"
      :steps="[1, 30]"
      :editable="false"
      hide-disabled-options
      :disabled-hours="disabledHours"
      transfer
      @on-change="handleChange($event, 'time')"
    /> -->
  </FormItem>
</template>

<script>
  import { FormItem, DatePicker } from 'iview';
  import VueSelect from 'vue-select';

  export default {
    components: { FormItem, DatePicker, VueSelect },
    props: {
      prop: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      type: {
        type: String,
        default: 'date'
      },
      value: {
        type: Object,
        default: () => ({ date: '', time: '' })
      },
      startDate: {
        type: Date,
        default: null
      },
      options: {
        type: Object,
        default: () => ({
          disabledDate(date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        })
      },
      disabled: {
        type: Boolean,
        default: false
      },
      // disabledHours: {
      //   type: Array,
      //   default: () => []
      // }
      disabledHours: {
        type: Boolean,
        default: false
      }
    },
    data() {
      const timeOptions = Array.from({ length: 24 }, (x, i) => {
        const hour = i >= 10 ? i : `0${i}`;
        return `${hour}:00`;
      });
      return {
        timeOptions
      };
    },
    methods: {
      handleChange(val, key) {
        if (key === 'date') {
          val = val.replace(/(\d{4}).(\d{2}).(\d{2}).$/, '$1-$2-$3');
        }
        const date = {
          ...this.value,
          [key]: val
        };
        this.$emit('input', date);
      }
    }
  };
</script>
